import { Ga4EventType, ga4Info } from '../../..'
import { AutoPlayOptionType } from '../index'
import { useAutoPlayStore } from '../store/autoPlayStore'

export class AutoPlayService {
  private callback: () => void

  select(selected: AutoPlayOptionType) {
    useAutoPlayStore.setState({
      current: selected,
    })
    ga4Info.addEvent(`${Ga4EventType.main_bet_autoplay}_${selected}`)
  }

  cancel() {
    useAutoPlayStore.setState({
      current: 0,
      isEnabledPanel: false,
      isPlaying: false,
    })
  }

  /**
   * @deprecated use cancel() instead
   */
  stop() {
    useAutoPlayStore.setState({
      isPlaying: false,
    })
  }

  startAutoPlay(callback: () => void) {
    this.callback = callback
    useAutoPlayStore.setState({
      isEnabledPanel: false,
      isPlaying: true,
    })
    this.play()
  }

  async play() {
    this.closeAutoPlayPopup()

    try {
      this.callback()
    }
    catch (_) {
      this.stop()
    }
  }

  public reduceRemain() {
    const remain = useAutoPlayStore.getState().current
    if (remain !== 'infinity') {
      useAutoPlayStore.setState({
        current: remain - 1,
        isPlaying: remain > 1,
      })
    }
  }

  private closeAutoPlayPopup() {
    if (useAutoPlayStore.getState().isEnabledPanel) {
      useAutoPlayStore.setState({
        isEnabledPanel: false,
      })
    }
  }
}
